import { render } from "./HighLevelWeeklyReport.vue?vue&type=template&id=7c1282eb&scoped=true"
import script from "./HighLevelWeeklyReport.vue?vue&type=script&lang=js"
export * from "./HighLevelWeeklyReport.vue?vue&type=script&lang=js"

import "./HighLevelWeeklyReport.vue?vue&type=style&index=0&id=7c1282eb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1282eb"]])

export default __exports__